import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@design-system/box';
import { CATEGORIES, FontAwesomeIconWithBackground, } from '@design-system/font-awesome-icon';
export const Icon = ({ iconStyle }) => (_jsx(Box, { mr: 4, children: _jsx(FontAwesomeIconWithBackground, { color: iconStyle.color, height: "35px", iconName: iconStyle.iconName, iconType: CATEGORIES.SOLID }) }));
//# sourceMappingURL=Icon.js.map